export default "__VITE_ASSET___QdQdpRE__"